import script from "./coldbox-modal.vue?vue&type=script&setup=true&lang=js"
export * from "./coldbox-modal.vue?vue&type=script&setup=true&lang=js"

import "./coldbox-modal.vue?vue&type=style&index=0&id=09ebeb6c&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-09ebeb6c"]])

export default __exports__